import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';

import FeatureMessage from 'components/FormMap/FeatureMessage';

import { sortFeaturesByTimestamp, filterFeatures } from 'helpers/featuresHelpers';

const FeaturesList = ({ features, filters, activityDates, ...props }) => {
  if (!features.length) {
    return <Alert message="Dessiner le parcours ou la zone concernée sur la carte" type="info" />;
  }

  sortFeaturesByTimestamp(features);

  return filterFeatures(features, filters, activityDates).map((feat, id) => (
    <FeatureMessage
      features={features}
      key={feat.feature.properties.id}
      id={id}
      feature={feat.feature}
      warning={feat.warning}
      incidence={feat.incidence}
      {...props}
    />
  ));
};

FeaturesList.propTypes = {
  features: PropTypes.arrayOf(PropTypes.shape({
    properties: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    geometry: PropTypes.object,
  })),
  selectedFeaturesId: PropTypes.arrayOf(PropTypes.string),
  filters: PropTypes.arrayOf(PropTypes.string.isRequired),
  editable: PropTypes.bool,
  deleteFeatureById: PropTypes.func,
};

FeaturesList.defaultProps = {
  filters: ['chemins'],
  features: [],
  selectedFeaturesId: [],
  editable: false,
  deleteFeatureById: () => {},
};

export default FeaturesList;



// WEBPACK FOOTER //
// ./src/components/FormMap/FeatureList.js